import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePopoverOrTooltip } from './usePopoverOrTooltip';
import { useCustomNotifications } from '../../../Notifications/CustomNotificationContext';
import { canShowTooltip } from './helpers';
import NotificationPopover from './NotificationPopover';
import TooltipPopover from './TooltipPopover';
import PopoverPopover from './PopoverPopover';
import { convertFromPopperPlacement } from '@wix/da-ds/pkg/popper/helpers';
import noop from '../../../utils/noop';
const PopoverWithTooltip = ({ children , tooltip , tooltipOffset , renderPopover , wrapperClassName , referenceClassName , allowMobile =false , notificationTypes , isDisabled , customNotificationRender , arrowClassName , contentClassName , placement , forceVisibleTooltip , renderReference , biData , openBiData =biData , closeBiData =biData  })=>{
    const { notifications  } = useCustomNotifications(notificationTypes);
    const hasNotification = !!notificationTypes && notifications.length > 0;
    const isMobile = useContext(MobileContext);
    const { showTooltip , onClose , onMouseEnter , onMouseLeave , onReferenceClick  } = usePopoverOrTooltip(!hasNotification && !!renderPopover, !hasNotification && !!tooltip, openBiData, closeBiData);
    const isActive = !isDisabled && canShowTooltip({
        hasNotification,
        isMobile,
        allowMobile,
        hasChildren: !!children,
        hasPopover: !!renderPopover,
        hasTooltip: !!tooltip
    });
    const { placement: primaryPlacement , secondaryPlacement  } = convertFromPopperPlacement(placement);
    const isShowingTooltip = forceVisibleTooltip || showTooltip === 'tooltip';
    const noPopoverOrTooltip = !hasNotification && (!isActive || !showTooltip && !forceVisibleTooltip);
    return /*#__PURE__*/ React.createElement("div", _extends({
        className: wrapperClassName
    }, !forceVisibleTooltip && {
        onMouseEnter,
        onMouseLeave
    }), hasNotification && /*#__PURE__*/ React.createElement(NotificationPopover, {
        arrowClassName: arrowClassName,
        contentClassName: contentClassName,
        referenceClassName: referenceClassName,
        tooltipOffset: tooltipOffset,
        notificationTypes: notificationTypes,
        customNotificationRender: customNotificationRender,
        onReferenceClick: onReferenceClick,
        renderReference: renderReference
    }, children), !hasNotification && isActive && isShowingTooltip && /*#__PURE__*/ React.createElement(TooltipPopover, {
        tooltip: tooltip,
        arrowClassName: arrowClassName,
        contentClassName: contentClassName,
        referenceClassName: referenceClassName,
        tooltipOffset: tooltipOffset,
        onReferenceClick: onReferenceClick,
        renderReference: renderReference
    }, children), !hasNotification && isActive && showTooltip === 'popover' && /*#__PURE__*/ React.createElement(PopoverPopover, {
        placement: primaryPlacement,
        secondaryPlacement: secondaryPlacement,
        arrowClassName: arrowClassName,
        contentClassName: contentClassName,
        referenceClassName: referenceClassName,
        tooltipOffset: tooltipOffset,
        onReferenceClick: onReferenceClick,
        renderPopover: renderPopover,
        onClose: onClose,
        renderReference: renderReference
    }, children), noPopoverOrTooltip && /*#__PURE__*/ React.createElement("div", {
        onClick: onReferenceClick,
        className: referenceClassName,
        style: referenceClassName ? {} : {
            display: 'inline-block'
        }
    }, renderReference ? renderReference({
        ref: noop
    }) : children));
};
PopoverWithTooltip.displayName = 'PopoverWithTooltip';
export default PopoverWithTooltip;
